export const datePickerStyle = { '@media (max-width: 700px)': { flexDirection: 'column' } }
